import { useState } from "react";
import axios from "axios";
import { getBaseUrlParams } from "../../../utils/getBaseUrlParams";
import { queryParams } from "../../../utils/queryParams";

const graph = axios.create({
  baseURL: queryParams.apiVersion + "/goals/visual_graph"
});

async function fetchGraph({ date, goalObjectId, metricType }) {
  let { short_url } = getBaseUrlParams();
  const params = {
    short_url,
    date,
    goal_object_id: goalObjectId,
    metric_class_name: metricType
  };
  const response = await graph.get("", { params });
  return response.data;
}

export function useFetchGraph() {
  const [graphData, setGraphData] = useState(null);
  const [graphLoading, setGraphLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const fetchGraphData = async ({ date, goalObjectId, metricType }) => {
    if (hasFetched) {
      return;
    }

    setGraphLoading(true);

    try {
      const data = await fetchGraph({ date, goalObjectId, metricType });
      setGraphData(data);
      setHasFetched(true);
    } catch (err) {
      console.error(err);
    } finally {
      setGraphLoading(false);
    }
  };

  return {
    graphData,
    graphLoading,
    setHasFetched,
    fetchGraphData,
    hasFetched
  };
}
